// Auth module types
// Note: User interface moved to src/core/stores/appStore.ts to avoid duplication

export interface LoginCredentials {
    email: string;
    password: string;
    device_id?: string;
}

export interface AuthResponse {
    status: 'success' | 'error';
    message: string;
    is_first_time_login: boolean;
    is_passcode_set?: boolean;
    device_id?: string;
    skip_passcode?: boolean;
    data: {
        jwtToken: string;
        /**
         * Emirates ID verify-otp (and similar): when true, skip ADHA journey
         * and use the normal authenticated dashboard.
         */
        convertedLead?: boolean;
        user?: {
            id?: string;
            email?: string;
            name?: string;
            [key: string]: any;
        };
    };
}

// Login form data types
export interface LoginFormData {
    email: string;
    password: string;
}

// Login validation errors
export interface LoginFormErrors {
    email?: string;
    password?: string;
    general?: string;
}

// Login form validation rules
export interface LoginValidationRules {
    email: {
        required: boolean;
        pattern: RegExp;
        message: string;
    };
    password: {
        required: boolean;
        minLength: number;
        message: string;
    };
}

// Login screen props
export interface LoginScreenProps {
    onLogin?: (email: string, password: string) => void | Promise<void>;
    onForgotPassword?: () => void;
    loading?: boolean;
    error?: string | null;
    initialEmail?: string;
}
